module.exports = __webpack_public_path__ + "static/media/cue.db73166b.png";